import { createSelector } from 'reselect';

const selectService = (state) => state;
const selectCoupon = createSelector(selectService, (state) => state);

const couponsSelectors = {
	selectService,
	selectCoupon,
};

export default couponsSelectors;
